import React from 'react';
import FlowCanvas from './components/FlowCanvas';
import 'reactflow/dist/style.css';
import './App.css'

function App() {
  return (
    <div className='ABC' >
      <FlowCanvas />
    </div>
  );
}

export default App;
